@if (!isAdminRole) {
  <section class="role-assignment-shell">
    <div class="role-assignment-card muted">
      <h1>Release Management</h1>
      <p>This section is available only for admin roles.</p>
    </div>
  </section>
} 
@else {
  @if (loader.isLoading && !isAddUserDialogVisible) {
    <div class="loader-class" aria-live="polite">
      <mat-spinner diameter="26"></mat-spinner>
      <div class="loader-message">{{ loader.message }}</div>
    </div>
  }
  <section class="role-assignment-shell">
    <div class="role-assignment-header">
      <div>
        <h1>Role Assignment</h1>
        <p>Assign access roles to team members: {{ getAssignableRoleNames() }}</p>
      </div>
    </div>

    <div class="role-assignment-card">
      <div class="team-members-controls">
        <div class="search-section">
          <input
            type="text"
            placeholder="Search users..."
            [(ngModel)]="searchUserQuery"
            (ngModelChange)="onSearchChange()"
            [disabled]="loader.isLoading"
            class="search-input">
        </div>

        <div class="action-buttons">
          <button type="button" class="add-update-btn" (click)="openAddUserModal()" [disabled]="loader.isLoading">
            Add New User
          </button>
        </div>
      </div>

      <div class="team-members-table">
        <table>
          <thead>
            <tr>
              <th class="col-number">&emsp;#</th>
              <th class="col-member">TEAM MEMBER</th>
              <th class="col-email">EMAIL</th>
              <th class="col-role">CURRENT ROLE</th>
              <th class="col-assign">ASSIGN</th>
            </tr>
          </thead>
          <tbody>
            @for (user of filteredUsers; track user.id; let idx = $index) {
              <tr>
                <td class="col-number">
                  <span class="user-index">{{ padIndex(idx) }}</span>
                </td>
                <td class="col-member">
                  <div class="member-info">
                    <span class="avatar">{{ user.avatarLabel }}</span>
                    <span class="name">{{ user.user_name }}</span>
                  </div>
                </td>
                <td class="col-email">{{ user.email_id }}</td>
                <td class="col-role">
                  <span
                    class="role-badge"
                    [class.role-badge-admin]="user.isAdmin"
                    [class.role-badge-developer]="user.isDeveloper">
                    ● {{ getRoleLabel(user.role_id) }}
                  </span>
                </td>
                <td class="col-assign">
                  <select
                    [(ngModel)]="user.selectedRoleId"
                    [disabled]="loader.isLoading"
                    class="role-dropdown">
                    @for (role of roleOptions; track role.role_id) {
                      <option [ngValue]="role.role_id">{{ role.role_name }}</option>
                    }
                  </select>
                  <button
                    type="button"
                    class="add-update-btn"
                    (click)="updateUserRole(user)"
                    [disabled]="loader.isLoading || user.selectedRoleId === user.role_id">
                    Update
                  </button>
                </td>
              </tr>
            } @empty {
              <tr>
                <td colspan="5" class="empty-state">No users found</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </section>

  <p-dialog
    [(visible)]="isAddUserDialogVisible"
    [header]="'Add New User'"
    [modal]="true"
    [closable]="!dialogLoader.isLoading"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '540px', 'max-width': '95vw' }">

    <div class="add-user-form">
      @if (dialogLoader.isLoading) {
        <div class="dialog-loading" aria-live="polite">
          <mat-spinner diameter="22"></mat-spinner>
          <span>{{ dialogLoader.message }}</span>
        </div>
      }

      <div class="form-group" [class.field-error]="isFieldInvalid(newUserModal.email_id)">
        <label for="add-user-search">Search User <span class="required">*</span></label>
        <app-user-autocomplete
          id="add-user-search"
          [entry]="newUserModal"
          [fieldToSave]="'email_id'"
          [inputDisabled]="dialogLoader.isLoading"
          [showDropdown]="false"
          (userSelected)="onAddUserSelected($event)">
        </app-user-autocomplete>
      </div>

      <div class="form-group">
        <label for="add-email">Email</label>
        <input
          id="add-email"
          type="email"
          [(ngModel)]="newUserModal.email_id"
          [disabled]="true"
          placeholder="—">
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="add-user-id">User ID</label>
          <input
            id="add-user-id"
            type="number"
            [(ngModel)]="newUserModal.user_id"
            [disabled]="true"
            placeholder="—">
        </div>
        <div class="form-group">
          <label for="add-user-name">User Name</label>
          <input
            id="add-user-name"
            type="text"
            [(ngModel)]="newUserModal.user_name"
            [disabled]="true"
            placeholder="—">
        </div>
      </div>

      <div class="form-row">
        <div class="form-group" [class.field-error]="isFieldInvalid(newUserModal.role_id)">
          <label for="add-role">Role <span class="required">*</span></label>
          <select id="add-role" [(ngModel)]="newUserModal.role_id" [disabled]="dialogLoader.isLoading">
            <option [ngValue]="null" disabled>Select role</option>
            @for (role of roleOptions; track role.role_id) {
              <option [ngValue]="role.role_id">{{ role.role_name }}</option>
            }
          </select>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <button type="button" class="btn-dialog-cancel" (click)="closeAddUserDialog()" [disabled]="dialogLoader.isLoading">
        Cancel
      </button>
      <button type="button" class="btn-dialog-save" (click)="addUser()" [disabled]="dialogLoader.isLoading">
        Add User
      </button>
    </ng-template>
  </p-dialog>
}